import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { IEditTransactionValue } from '../pages/useInventoryStore/type';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BulkModifyTransactionRequestInfo } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 数値編集を行う
 * 一括で数値情報を変更する
 */
export class UpsertTransactionValuesUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - 取引情報のリポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 一括数値情報変更を実行する
   * @param aggregateBusinessId - 集計ID
   * @param values - 編集する情報
   */
  async Execute(aggregateBusinessId: string, values: IEditTransactionValue[]): Promise<INetworkResult<string, Error>> {
    const request: BulkModifyTransactionRequestInfo = {
      aggregateBusinessId: aggregateBusinessId,
      data: values.map((v) => {
        // currentInventoryの場合はexecutionDateから年月を取得
        let targetYear: number;
        let targetMonth: number;
        if (v.type === 'currentInventory') {
          if (!v.executionDate) {
            throw new Error('currentInventory type requires executionDate');
          }
          targetYear = v.executionDate.getFullYear();
          targetMonth = v.executionDate.getMonth() + 1;
        } else {
          const targetYearMonth = DateService.getShiftedIYearMonthFromNowDateByMonths(v.month);
          targetYear = targetYearMonth.year;
          targetMonth = targetYearMonth.month;
        }
        return {
          transactionType: v.type === 'endInventory' ? 'inventory' : v.type,
          amount: v.value,
          targetYear: targetYear,
          targetMonth: targetMonth,
          baseBusinessId: v.baseBusinessId ?? undefined,
          receivedYear: v.receivedYearMonth && v.receivedYearMonth.year,
          receivedMonth: v.receivedYearMonth && v.receivedYearMonth.month,
        };
      }),
    };

    try {
      const result = await this.repository.bulkModifyTransaction(request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: 'ok',
            },
          };
        case 'error':
          throw Error(result.status.error.message);
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: error instanceof Error ? error : Error('想定外のエラー'),
        },
      };
    }
  }
}
